// extracted by mini-css-extract-plugin
export default {"root":"styles_root__nSBDk","root--contacts":"styles_root--contacts__oIF3w","icon":"styles_icon__3tN4Z"};